import React, { useMemo } from "react";
import {
  ThemeProvider,
  ThemeContext,
  type CSSObject,
  type CSSProp,
  type DefaultTheme,
  type ExecutionContext,
  type RuleSet,
} from "styled-components";
import { formBaseTheme } from "./theme";

declare module "react" {
  interface Attributes {
    css?: CSSProp;
  }
}

declare module "styled-components" {
  export interface DefaultTheme {
    fonts?: Record<string, CSSObject | string>;
  }
}

export enum FormSize {
  default = "medium",
  large = "large",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  medium = "medium",
  small = "small",
}
interface FormThemeProps {
  size: FormSize;
  children: React.ReactNode;
}

interface ThemeProps {
  theme?: DefaultTheme & {
    form?: {
      size?: FormSize;
    };
  };
  size?: FormSize | number | string;
}

export function FormThemeProvider(props: FormThemeProps) {
  let currentTheme = React.useContext(ThemeContext);

  if (!currentTheme) {
    currentTheme = formBaseTheme;
  }
  const formTheme = useMemo(
    () => ({
      ...currentTheme,
      form: {
        size: props.size ?? FormSize.default,
      },
    }),
    [currentTheme, props.size]
  );

  return <ThemeProvider theme={formTheme}>{props.children}</ThemeProvider>;
}

function checkFormSize(props: ThemeProps, size: FormSize) {
  const sizeFlag = (props as Record<string, unknown>)[size];

  return (
    (props.theme?.form?.size === size && !props.size) ||
    props.size === size ||
    Boolean(sizeFlag)
  );
}

export function formSizeStyles(size: FormSize, code: RuleSet<any>) {
  return (props: ExecutionContext & ThemeProps) => {
    if (!checkFormSize(props, size)) {
      return undefined;
    }

    return code;
  };
}

export function formSizeAttributes(
  size: FormSize,
  props: ThemeProps,
  attrs: any
) {
  return checkFormSize(props, size) ? attrs : {};
}
